export default __webpack_public_path__ + "static/consumer-elec-1f9a8490793c929114ec17d117b4a8ee.jpeg";